import { ContentCard } from "@msuite/ui/content-card";
import { DataGrid } from "@msuite/ui/data-grid";
import { icon } from "@msuite/ui/icons";
import { Link } from "@msuite/ui/link";
import { useTranslation } from "@msuite/ui/localization";
import { OrderStateTag } from "@msuite/ui/tag";
import { moment } from "@msuite/utils/date";
import { getDeliveryWindowString, getOrderNumberString } from "@msuite/utils/stock";
import { guardString } from "@msuite/utils/strings";
import { NoteText } from "@/components/notes";
import { useOrder } from "@/hooks/use-order";
import type { OrderPanelBaseProps } from "../../shared";

export function OrderInformation({ orderId }: OrderPanelBaseProps) {
	/** Hooks */
	const { t } = useTranslation();

	/** Query */
	const { order } = useOrder(orderId);

	/** Render */
	return (
		<ContentCard
			title={t("general.information")}
			icon={icon("Info")}
		>
			<DataGrid>
				<DataGrid.Row>
					<DataGrid.Label>{t("stock.order_no")}</DataGrid.Label>
					<DataGrid.Value>{getOrderNumberString(order?.number)}</DataGrid.Value>
				</DataGrid.Row>
				<DataGrid.Row>
					<DataGrid.Label>{t("general.state")}</DataGrid.Label>
					<DataGrid.Value>
						{order ? <OrderStateTag state={order.state} /> : guardString(null)}
					</DataGrid.Value>
				</DataGrid.Row>
				<DataGrid.Row>
					<DataGrid.Label>{t("stock.delivery_window")}</DataGrid.Label>
					<DataGrid.Value>
						{getDeliveryWindowString(order?.deliveryDate, order?.tourWave)}
					</DataGrid.Value>
				</DataGrid.Row>
				<DataGrid.Row>
					<DataGrid.Label>{t("stock.tour_wave")}</DataGrid.Label>
					<DataGrid.Value>{guardString(order?.tourWave?.name)}</DataGrid.Value>
				</DataGrid.Row>
				<DataGrid.Row>
					<DataGrid.Label>{t("projects.project")}</DataGrid.Label>
					<DataGrid.Value>
						{order ? (
							<Link href={`/projects/${order.projectId}`}>{guardString(order.projectName)}</Link>
						) : (
							guardString(null)
						)}
					</DataGrid.Value>
				</DataGrid.Row>
				<DataGrid.Row>
					<DataGrid.Label>{t("general_fields.created_by")}</DataGrid.Label>
					<DataGrid.Value>{guardString(order?.userName)}</DataGrid.Value>
				</DataGrid.Row>
				<DataGrid.Row>
					<DataGrid.Label>{t("general_fields.created_at")}</DataGrid.Label>
					<DataGrid.Value>{moment(order?.createdAt).longFormat()}</DataGrid.Value>
				</DataGrid.Row>
				<DataGrid.Row>
					<DataGrid.Label>{t("notes.note")}</DataGrid.Label>
					<DataGrid.Value>
						<NoteText note={guardString(order?.note)} />
					</DataGrid.Value>
				</DataGrid.Row>
			</DataGrid>
		</ContentCard>
	);
}
